export const URI = {
    // CLASSIFICATION
    GOODNOTES: "hkep-classification:GOODNOTES",
    // CLASSIFICATION EN
    GOODNOTES_EN: "hkep-classification:GOODNOTES_EN",
    OPEN_GOODNOTES: "OPEN_GOODNOTES_Y",
}



// WEBPACK FOOTER //
// ./resources/assets/config/uri.js